/* eslint-disable no-unused-vars */
import React from "react";
import { useSelector } from "react-redux";
import { contributorData } from "../../../../../../../../../store/Users/selectors";
import { InputTextContainer, Text } from "../../../../styled";
import GenericInput from "../../../GenericInput";
import { getContribData } from "./constants";

const ContributorInputs = () => {
  const items = useSelector(contributorData);
  const elements = getContribData(items);

  const getInputs = (element) => {
    return (
      <InputTextContainer>
        <Text>{element.text}</Text>
        <GenericInput
          name={element.name}
          value={element.value}
          onBlur={element.onBlur}
          onChange={element.onChange}
          checked={element.checked}
          errorMessage={element.errorMessage}
        />
      </InputTextContainer>
    );
  };

  return <div>{elements.map(getInputs)}</div>;
};

export default ContributorInputs;
